<template>
  <div class="LoginStar">
    <canvas id="canv" style="width: 100%; height: 100%"></canvas>
  </div>
</template>

<script>
//这个是星空效果，跟随鼠标移动星空
import {
  initAnimate1,
  startAnimate1,
  cancelAnimate1,
} from "../assets/animate1.js";
export default {
  data() {
    return {
      canva: {},
      cxt: {},
      headLineAnimate0: {
        classes: "flipInX",
        delay: 10,
        duration: 5000,
      },
    };
  },
  mounted() {
    this.canvas = document.getElementById("canv");
    this.cxt = this.canvas.getContext("2d");
    initAnimate1(this.canvas, this.cxt);
    startAnimate1();
  },
  beforeDestroy() {
    cancelAnimate1();
  },
};
</script>

<style lang="css" scoped>
.LoginStar {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  /* z-index: -1; */
}
</style>